import { render } from "./CustomerTransactionTable.vue?vue&type=template&id=59b5a6c6&scoped=true"
import script from "./CustomerTransactionTable.vue?vue&type=script&lang=js"
export * from "./CustomerTransactionTable.vue?vue&type=script&lang=js"

import "./CustomerTransactionTable.vue?vue&type=style&index=0&id=59b5a6c6&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59b5a6c6"]])

export default __exports__